import React, { Fragment } from 'react';

/** Routing */
import { BrowserRouter as Router } from 'react-router-dom';

/** components */
import  Menu  from './components/menu';

function App() {
  return (
    <Router>
      <Fragment>
        <Menu />
      </Fragment>
    </Router>
  );
}

export default App;
